import React from "react";
import "../copia-dados-deposito/Style.css";
import CopiarDados from "../../../components/acesso-rapido/deposito/copiar-dados/index";

export default function () {
  return <CopiarDados />;
}
